import { useEffect } from 'react';

export type HiddenProps = {
  label: string;
  value: string;
  hiddenValue: string;
  onChange?: (value: string) => void;
};

export function Hidden({ value, label, hiddenValue, onChange }: HiddenProps) {
  const finalValue = hiddenValue ?? value;

  useEffect(() => {
    onChange?.(finalValue);
    // oxlint-disable-next-line exhaustive-deps
  }, [finalValue]);

  return <input type="hidden" defaultValue={finalValue} name={label} />;
}
